<template>
    <div>
        <fpzInvacc-common></fpzInvacc-common>
    </div>
</template>
<script>
import fpzInvaccCommon from './fpzInvaccCommon';
export default {
    name: 'fpzInvaccAdd',
    components: {
        fpzInvaccCommon
    },
    data () {

    }
}
</script>